var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container md-layout-column"},[_c('menu-bar'),_c('md-content',{staticClass:"TL_BookSession"},[_c('router-view',{staticClass:"Page"})],1),_c('toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }